<template>
    <div class="beer">
       <article>
        <div class="beer-info">
          <h3 v-bind:beer=beer  >{{ beer.beerName }} ${{ beer.price }}</h3>
          <h4>{{ beer.style }}</h4>
          <h4>ABV: {{ beer.abv }}</h4>
          <h4>Average Rating: {{rating}}<i 
                class="fa-solid fa-star"></i></h4>
          <p>{{ beer.description }}</p>

        </div>
        <div class="beer-image-container">
          <img v-bind:src="beer.imageUrl" v-if="beer.imageUrl !== null" />
          <img src="../assets/mug.png" v-if="beer.imageUrl === null" />
        </div>
      </article>
    </div>
  </template>
  
  <script>
  
  
  export default {
    
    name: "beer-detail",
    data() {
      return {
        errorMsg: "",
        paramsId: parseInt(this.$route.params.id),
      };
    },

    computed: {
      beer() {
        return this.$store.getters.getBeerByID(this.paramsId)
      },
      rating() {
        return this.$store.getters.getAverageRatingForBeerId(this.paramsId)
      }
    },
  };
  </script>
  